import { useState } from 'react';
import { X, RefreshCw } from 'lucide-react';
import PINKeyboard from './PINKeyboard';
import axios from 'axios';
import { toast } from 'sonner';
import { API_URL } from '@/config';

const API = API_URL;

export default function RefreshPasswordModal({ onClose, onSuccess }) {
  const [code, setCode] = useState('');
  const [verifying, setVerifying] = useState(false);

  const handleNumberClick = (num) => {
    if (code.length < 4) {
      const newCode = code + num;
      setCode(newCode);
      
      // Auto-verify when 4 digits entered
      if (newCode.length === 4) {
        verifyCode(newCode);
      }
    }
  };

  const handleBackspace = () => {
    setCode(code.slice(0, -1));
  };

  const handleClear = () => {
    setCode('');
  };

  const verifyCode = async (codeToVerify) => {
    setVerifying(true);
    try {
      const response = await axios.post(`${API}/settings/verify-refresh-code`, {
        code: codeToVerify
      });

      if (response.data.valid) {
        toast.success('Code correct - Refreshing...');
        onSuccess();
      } else {
        toast.error('Incorrect code');
        setCode('');
      }
    } catch (error) {
      console.error('Error verifying code:', error);
      toast.error('Failed to verify code');
      setCode('');
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-50">
      <div className="glass-card max-w-sm w-full p-4 relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-white/70 hover:text-white"
        >
          <X size={20} />
        </button>

        <div className="flex flex-col items-center mb-4">
          <div className="bg-blue-500/20 p-2 rounded-full mb-2">
            <RefreshCw size={24} className="text-blue-500" />
          </div>
          <h2 className="text-xl font-bold mb-1">Refresh Page</h2>
          <p className="text-center text-white/70 text-sm mb-1">Enter 4-digit code</p>
        </div>

        {/* Code Display */}
        <div className="flex justify-center gap-2 mb-4">
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              className={`w-10 h-10 rounded-lg border-2 flex items-center justify-center text-xl font-bold ${
                code.length > i
                  ? 'border-blue-500 bg-blue-500/20'
                  : 'border-white/30 bg-white/5'
              }`}
            >
              {code.length > i ? '•' : ''}
            </div>
          ))}
        </div>

        {/* Custom Keyboard */}
        <PINKeyboard
          onNumberClick={handleNumberClick}
          onBackspace={handleBackspace}
          onClear={handleClear}
        />

        {verifying && (
          <p className="text-center mt-2 text-white/50 text-xs">Verifying...</p>
        )}
      </div>
    </div>
  );
}
